import React from "react";
import { Modal, Form, Input, message, Button } from "antd";
import { useAsync } from "../../../../utils/use-async";
import { client } from "../../../../utils/api-client";
import { Spinner } from "../../../lib"

const AddSection = ({ modal, fetchSections, handleCancel, setModal }) => {
  const { isLoading, run, isError, error } = useAsync();
  const addSection = (values) => {
    run(client("section/add", {body: values}).then(res => {
        message.success(res.message)
        setModal(false)
        fetchSections()
    } 
        ))

  };

  return (
    <Modal title="Add Project" visible={modal} onCancel={handleCancel}>
      <Form
        size="middle"
        layout="horizontal"
        labelCol={{
          span: 6,
        }}
        wrapperCol={{
          span: 16,
        }}
        onFinish={addSection}
      >
        <Form.Item
          label="Project Name"
          name="name"
          rules={[
            {
              required: true,
              message: "Please input section name!",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item {...{ wrapperCol: { offset: 8, span: 16 } }}>
          <Button type="primary" htmlType="submit">
            Submit{" "}
            {isLoading && (
              <span style={{ marginLeft: "5px", verticalAlign: "middle" }}>
                <Spinner />
              </span>
            )}
          </Button>
        </Form.Item>
        {isError && <p style={{ color: "red" }}>{error.message}</p>}
      </Form>
    </Modal>
  );
};

export default AddSection;
